"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useButtonSpacing = useButtonSpacing;
var _getButtonSpacing = require("../utils/getButtonSpacing");
function useButtonSpacing({
  compact,
  startIcon,
  endIcon,
  flush
}) {
  return (0, _getButtonSpacing.getButtonSpacing)({
    compact,
    startIcon,
    endIcon,
    flush
  });
}